import {useEffect, useState} from 'react';
import {useChat} from './ChatProvider';

export default function useJobChatStatus(identity, jobId, assignment) {
    const {jobChat} = useChat();
    const [value, setValue] = useState();
    useEffect(() => {
        setValue(undefined);
        if (!identity || !jobId) return undefined;
        return jobChat.subscribe(String(jobId), setValue);
    }, [jobChat, identity, jobId, assignment]);
    return {...value, refresh: () => jobChat.refresh(String(jobId))};
}
